import {cn} from 'platform/shared-tw';

import {useId} from 'react';

import {
  createKeyDownHandler,
  partFill,
  partStroke,
  type DiagramVariant,
} from '../shared/partVariants';

// TODO: rename this component and file to the real automotive part name once confirmed by design
const SOME_PART_B_BOTTOM_OFFSET = 41;
const SOME_PART_B_LEFT_OFFSET = 86;
const PART_B_TITLE_ID = 'some-part-b-title';

interface SomePartBProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function SomePartB(props: SomePartBProps) {
  const uid = useId();
  const titleId = `${PART_B_TITLE_ID}-${uid}`;

  return (
    <svg
      width="102"
      height="38"
      viewBox="0 0 102 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute focus:outline-none focus-visible:outline-none cursor-pointer group"
      style={{bottom: SOME_PART_B_BOTTOM_OFFSET, left: SOME_PART_B_LEFT_OFFSET}}
      onClick={props.onClick}
      onKeyDown={createKeyDownHandler(props.onClick)}
      role={props.onClick ? 'button' : undefined}
      tabIndex={props.onClick ? 0 : undefined}
      aria-labelledby={titleId}
    >
      <title id={titleId}>Some Part B</title>
      <path
        d="M44.9431 4.99487C44.9431 1 41.9399 1 40.939 1H4.90243C0.898361 1 0.454278 4.99487 1.4539 6.99231C3.45577 10.9872 25.9915 26.092 34.4874 31.9603C42.9833 37.8285 85.4545 36.9539 91.9909 36.9539C101 36.9539 101 33.9577 101 30.9616L101 21.9731C101 16.9795 96.9959 15.9808 94.9939 15.9808H55.9543C47.946 15.9808 44.9431 11.9859 44.9431 4.99487Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      />
      <path
        d="M44.9431 4.99487C44.9431 1 41.9399 1 40.939 1H4.90243C0.898361 1 0.454278 4.99487 1.4539 6.99231C3.45577 10.9872 25.9915 26.092 34.4874 31.9603C42.9833 37.8285 85.4545 36.9539 91.9909 36.9539C101 36.9539 101 33.9577 101 30.9616L101 21.9731C101 16.9795 96.9959 15.9808 94.9939 15.9808H55.9543C47.946 15.9808 44.9431 11.9859 44.9431 4.99487Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M37.44 15.6592C39.52 14.5596 39.52 12.3604 37.44 11.3739C35.36 10.3873 29.1108 7.41234 29.1108 7.41234C29.1108 7.41234 26 5.76298 26 9.0617V17.8583C26 21.157 29.1108 19.6621 29.1108 19.6621L37.44 15.6592Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
